<template>
	<v-dialog v-model="open" max-width="440" :attach="overlayTarget">
		<v-card class="points-claim-dialog">
			<v-card-title class="points-claim-dialog__title">
				<md-icon>paid</md-icon>
				{{ promoName }}
			</v-card-title>

			<v-card-text>
				<v-alert v-if="error" type="error" variant="tonal" density="compact" class="mb-3">{{ error }}</v-alert>
				<v-text-field v-model.number="editablePoints" type="number" :label="t('PointsToClaimLabel')" :min="1" variant="outlined" density="comfortable" class="mb-2" />
				<v-textarea v-model="comment" :label="t('Comment')" rows="3" variant="outlined" density="comfortable" hide-details />
			</v-card-text>

			<v-card-actions>
				<v-btn variant="text" @click="open = false">{{ t('Cancel') }}</v-btn>
				<v-btn variant="text" :loading="loading" class="points-claim-dialog__confirm-btn" @click="confirm">{{ t('Valid') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useTranslator } from '@/utils/useTranslator';

const t = useTranslator();

const props = defineProps({
	modelValue: { type: Boolean, default: false },
	promoName: { type: String, default: '' },
	calculatedPoints: { type: Number, default: 0 },
	loading: { type: Boolean, default: false },
	error: { type: String, default: null },
	overlayTarget: { type: Object, default: null },
});

const emit = defineEmits(['update:modelValue', 'confirm']);

const open = ref(props.modelValue);
const editablePoints = ref(0);
const comment = ref('');

watch(
	() => props.modelValue,
	(v) => {
		open.value = v;
		if (v) {
			editablePoints.value = 0;
			comment.value = '';
		}
	}
);

watch(open, (v) => emit('update:modelValue', v));

function confirm() {
	emit('confirm', { pointsClaimed: editablePoints.value, comment: comment.value });
}
</script>
